import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TextInput, TextInputProps } from '@sato/components';

export const HookFormTextInput = ({
  name,
  showErrorMessage = true,
  ...props
}: {
  name: string;
  /**
   * Whether to show error message under the input on error.
   * If `false`, input is styled with error styles without the message.
   */
  showErrorMessage?: boolean;
} & TextInputProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <TextInput
          {...props}
          {...field}
          error={
            showErrorMessage
              ? fieldState.error?.message
              : !!fieldState.error?.message
          }
        />
      )}
    />
  );
};
